import { motion } from "framer-motion";

const stages = [
  {
    code: "Marhalah I",
    title: "Tahsin & Tajwid",
    duration: "",
    desc: "Pembenahan makhraj, sifatul huruf, dan kaidah tajwid riwayat Hafsh 'an 'Ashim. Pondasi untuk hafalan yang tartil.",
    points: [
      "Talaqqi langsung dengan ustadz",
      "Setoran bacaan harian dengan tahsin",
      "Evaluasi mingguan",
    ],
  },
  {
    code: "Marhalah II",
    title: "Tahfizh Al-Qur'an",
    duration: "",
    desc: "Hafalan progresif 30 juz dengan target 2 - 3 halaman per hari. Murajaah berjenjang (harian, mingguan, bulanan) menjaga kualitas hafalan.",
    points: [
      "Setoran ziyadah & murajaah harian",
      "Sistem 'halaqah' kelompok kecil",
      "Buku Mutaba'ah Yaumiyah",
    ],
  },
  {
    code: "Marhalah III",
    title: "Itqan",
    duration: "",
    desc: "Penguatan mutqin sampai layak diuji bil-ghoib.",
    points: [
      "Tasmi' 5, 10, 15, 20, 25 dan 30 juz sekali duduk",
      "Ujian akhir bil-ghoib 30 juz",
    ],
  },
  {
    code: "Marhalah IV",
    title: "Dirasah Islamiyah",
    duration: "",
    desc: "Materi pendamping: fiqih, aqidah, sirah, bahasa Arab, dan adab. Membentuk hafizh yang berilmu dan beradab.",
    points: [
      "Kurikulum tarbiyah qur'aniyah",
      "Pengajaran bahasa Arab",
      "Pembinaan akhlak & leadership",
      "Pengabdian",
    ],
  },
];

export default function Program() {
  return (
    <section
      id="program"
      className="relative bg-forest text-parchment py-24 md:py-32 overflow-hidden"
      data-testid="program-section"
    >
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1550867571-6d0bc79eb6f1?crop=entropy&cs=srgb&fm=jpg&q=80')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="text-xs tracking-[0.4em] uppercase text-gold"
          >
            Kurikulum Tahfizh
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="mt-4 font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.1]"
          >
            Perjalanan empat marhalah,<br />
            <span className="italic text-gold">satu cita: 30 juz mutqin.</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-6 text-parchment/70 max-w-xl leading-relaxed"
          >
            Setiap marhalah dirancang berurutan agar santri tidak sekadar hafal,
            namun memahami, mengamalkan, dan kelak mengajarkan.
          </motion.p>
        </div>

        <div className="mt-20 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {stages.map((s, i) => (
            <motion.div
              key={s.code}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative p-8 md:p-10 border border-gold/30 rounded-2xl lift bg-forest/30 backdrop-blur-sm"
              data-testid={`program-stage-${i}`}
            >
              <div className="flex items-start justify-between gap-4">
                <span className="text-xs tracking-[0.3em] uppercase text-gold">{s.code}</span>
                {s.duration && <span className="text-xs text-parchment/60">{s.duration}</span>}
              </div>
              <h3 className="mt-4 font-serif-display text-3xl md:text-4xl">{s.title}</h3>
              <p className="mt-4 text-parchment/75 leading-relaxed">{s.desc}</p>
              <ul className="mt-6 space-y-2">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-3 text-sm text-parchment/85">
                    <span className="mt-2 inline-block w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0" />
                    {p}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
